var map = {
	"./attach-file.svg": "./js/src/libs/ckeditor/icons/attach-file.svg",
	"./bg-color.svg": "./js/src/libs/ckeditor/icons/bg-color.svg",
	"./bold.svg": "./js/src/libs/ckeditor/icons/bold.svg",
	"./bookmark-anchor.svg": "./js/src/libs/ckeditor/icons/bookmark-anchor.svg",
	"./code.svg": "./js/src/libs/ckeditor/icons/code.svg",
	"./emoji.svg": "./js/src/libs/ckeditor/icons/emoji.svg",
	"./format-align-center.svg": "./js/src/libs/ckeditor/icons/format-align-center.svg",
	"./format-align-left.svg": "./js/src/libs/ckeditor/icons/format-align-left.svg",
	"./format-align-right.svg": "./js/src/libs/ckeditor/icons/format-align-right.svg",
	"./hr.svg": "./js/src/libs/ckeditor/icons/hr.svg",
	"./image.svg": "./js/src/libs/ckeditor/icons/image.svg",
	"./iorad.svg": "./js/src/libs/ckeditor/icons/iorad.svg",
	"./italic.svg": "./js/src/libs/ckeditor/icons/italic.svg",
	"./link.svg": "./js/src/libs/ckeditor/icons/link.svg",
	"./list.svg": "./js/src/libs/ckeditor/icons/list.svg",
	"./loading-spinner.svg": "./js/src/libs/ckeditor/icons/loading-spinner.svg",
	"./more.svg": "./js/src/libs/ckeditor/icons/more.svg",
	"./ordered-list.svg": "./js/src/libs/ckeditor/icons/ordered-list.svg",
	"./poll.svg": "./js/src/libs/ckeditor/icons/poll.svg",
	"./quote.svg": "./js/src/libs/ckeditor/icons/quote.svg",
	"./remove-format.svg": "./js/src/libs/ckeditor/icons/remove-format.svg",
	"./source.svg": "./js/src/libs/ckeditor/icons/source.svg",
	"./spoiler.svg": "./js/src/libs/ckeditor/icons/spoiler.svg",
	"./table.svg": "./js/src/libs/ckeditor/icons/table.svg",
	"./text-color.svg": "./js/src/libs/ckeditor/icons/text-color.svg",
	"./underline.svg": "./js/src/libs/ckeditor/icons/underline.svg",
	"./variable.svg": "./js/src/libs/ckeditor/icons/variable.svg",
	"./video.svg": "./js/src/libs/ckeditor/icons/video.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./js/src/libs/ckeditor/icons sync recursive ^\\.\\/.*\\.svg$";